
import { Component, Vue, Watch, Mixins, Prop } from 'vue-property-decorator';
import CommonTab from '@/components/common/CommonTab.vue';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import CommonBlockTitle from '@/components/common/CommonBlockTitle.vue';
import CommonDropMenu from '@/components/common/CommonDropMenu.vue';
import CommonTableHead from '@/components/common/CommonTableHead.vue';
import CommonDialog from '@/components/common/CommonDialog';
import SingleBuy from './SingleBuy.vue';
import SingleRaise from './SingleRaise.vue';
import SingleCover from './SingleCover.vue';
import SingleGrade from './SingleGrade.vue';
import {
  homeTitle,
  homeSingleTabList,
  singleRankHead,
  singleRankDropMenu,
  reportCoverDropMenu,
  STAT,
} from '@/config/config';
import { pushBy2804 } from '@/utils/tools';
import { getHomeGradeUpRank, getRankSingle, getHomeBuyRank } from '@/apis/index';
import { dropMenuProject } from '@/types/dropMenu';
import { SingleRankTab } from '@/utils/mixin';
import { tableHeaderProject } from '@/types/tableHeader';

@Component({
  components: {
    CommonTab,
    CommonBlockLine,
    CommonBlockTitle,
    CommonDropMenu,
    CommonTableHead,
    CommonDialog,
    SingleBuy,
    SingleRaise,
    SingleCover,
    SingleGrade,
  },
})
export default class SingleRank extends Mixins(SingleRankTab) {
  @Prop() private upspaceBannerImg!: string;
  // 个股排行的时间筛选条件
  dropMenu = [
    {
      list: singleRankDropMenu,
      default: singleRankDropMenu[0].label,
    },
    {
      list: reportCoverDropMenu,
      default: '近5日',
    },
    {
      list: singleRankDropMenu,
      default: singleRankDropMenu[0].label,
    },
    {
      list: singleRankDropMenu,
      default: singleRankDropMenu[0].label,
    },
  ];
  // 首页用到的模块标题信息
  homeTitle = homeTitle;
  apiList = ['', getRankSingle, getHomeGradeUpRank, getHomeBuyRank];
  // 个股的tab信息
  singleTabList = JSON.parse(JSON.stringify(homeSingleTabList(STAT.homeRecommend)));
  // 表格头信息
  singleRankHead: tableHeaderProject[][] = singleRankHead;
  // 获取个股展示信息对应的表头信息
  singleListHead = singleRankHead[0];
  // 筛选事件信息
  selectedDate = ['1m', '5', '1m', '1m'];
  // 激活状态
  activeStatus = [true, false, false, false];
  // 当前展示的组件名称 tab切换组件
  activeComponent = 'SingleRaise';
  // 埋点数组
  statList = ['gegu.kongjian', 'gegu.fugai', 'gegu.shangtiao', 'gegu.mairu'];
  @Watch('activeIndex')
  onActiveIndexChanged(newValue, oldValue) {
    // 处理tab数据
    this.$set(this.singleTabList[oldValue], 'isActive', false);
    this.$set(this.singleTabList[newValue], 'isActive', true);
  }
  showDialog(index) {
    // 获取弹窗展示的类型
    const type = this.singleListHead[index].confuseType;
    if (type) {
      // 展示dialog 实例化 这里需要优化
      const Dialog = Vue.extend(CommonDialog);
      const tempElement = new Dialog({
        propsData: {
          // 设置弹窗的类型
          type,
        },
      }).$mount();
      document.body.appendChild(tempElement.$el);
    }
  }
  handleCardJump() {
    // 首页卡片上涨空间查看更多跳转到模块
    const stockCode = window.getParam('stockcode');
    if (window.getParam('jumpTab') === 'raise' && stockCode) {
      // 需要定义接口调用的字段配置
      this.dropMenu[0].default = '近半年';
      this.selectedDate[0] = '6m';
    }
  }
  toRank() {
    let singledate = '';
    const selectDate = this.selectedDate[this.activeIndex];
    this.dropMenu[this.activeIndex].list.forEach(item => {
      if (item.value === selectDate) {
        singledate = item.label;
      }
    });
    pushBy2804('/rank', {
      // 用来跳转rank激活指定的swiper和tab
      tab: `0-${this.activeIndex}`,
      [`singledate${this.activeIndex}`]: singledate,
      [`singleselect${this.activeIndex}`]: selectDate,
    });
  }
  handleSingleTabClick(index: number) {
    // tab点击事件处理 索引缓存
    this.activeStatus[index] = true;
    this.activeIndex = index;
    this.singleListHead = this.singleRankHead[index];
    // 激活对应的组件
    const componentArr = ['SingleRaise', 'SingleCover', 'SingleGrade', 'SingleBuy'];
    this.activeComponent = componentArr[index];
  }
  changeInfo(info: dropMenuProject) {
    // 处理选中的时间
    this.$set(this.selectedDate, this.activeIndex, info.value);
    this.$set(this.dropMenu[this.activeIndex], 'default', info.label);
  }
  created() {
    this.handleCardJump();
  }
}
